export default __webpack_public_path__ + "2e0e7de3de46e0e19f51f0f2c94ef130.png";